<template>
  <div class="animated revealUp">
    <div class="section-title mb-4">{{'Schedule Transactions'}}</div>
    <div class="white-wrapper pb-0 overflow-hidden">
      <p style="font-size:20px">Transaction Details</p>
      <div class="swc-report">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th>Transaction Booking Date & Time</th>
              <th>Show Booking Code</th>
              <th>Screen Name</th>
              <th>Film Name</th>
              <th>Show Date & Time</th>
              <th>Seats</th>

              <th>Amount</th>

              <th>Offer | Voucher</th>
            </tr>
          </thead>
          <tbody v-for="(user, userIndex) in transactionList" :key="userIndex" class="sph-report">
            <tr>
              <td>{{user.t_booking_date_time | fulldatemonparse}}</td>
              <td>{{user.sb_booking_code}}</td>
              <td>{{user.screen_name}}</td>
              <td>{{user.film_name}}</td>

              <td>{{user.t_show_date | dateparse}} {{user.t_show_time}}</td>
              <td>{{user.seats}}</td>
              <td>{{user.total_amount.toFixed(this.MIN_FRACTION_DIGITS)}}</td>
              <td>{{user.offer_name? user.offer_name : user.voucher_name? user.voucher_name : "-"}}</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td colspan="8">
                <h3 v-if="transactionList.length == 0" class="ml-3">{{ 'No records found' }}</h3>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import ScheduleCommentService from "@/services/ScheduleCommentsService.js";

export default {
  data() {
    return {
      transactionList: []
    };
  },
  mounted() {
    this.getScheduleTransactions();
  },
  methods: {
    getScheduleTransactions() {
      const { ss_id } = this.$route.params;
      ScheduleCommentService.GetScheduleTransactions({ ss_id: ss_id })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.transactionList = data.Records;
              console.log("this.transactionList :", this.transactionList);
            }
            // this.schedule_show_obj = data.Records[0];
            // console.log("this.schedule_show_obj :", this.schedule_show_obj);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ScheduleCommentsComponent/ScheduleTransactions.vue